import React, { useEffect, useState, useMemo } from 'react';
import { Space, Table, Tag, Button, Image, Card, Input, Flex, Select } from 'antd';
import { useNavigate, useSearchParams } from "react-router";
import { EditOutlined, EyeOutlined } from '@ant-design/icons';
import ProductService from 'services/sitemap';
import { useApp } from "contexts/app";
import _ from "lodash"
const { Search } = Input;
const service = new ProductService();


const ProductTag = () => {
  let navigate = useNavigate();
  const [data, setData] = useState([]);
  const { showNotify, modal, showLoading, prompt } = useApp();
  const [filter, setFilter] = useState({})





  const loadData = async () => {
    var list = await service.list();
    setData(list);
  }

  const createTag = async () => {
    showLoading(true);
    var text =await service.get();
    var blob = new Blob([text], { type: 'text/plain' });
    var link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'sitemap.txt';
    link.click();
    showLoading(false)
  }







  return (

    <Space direction="vertical" size={16} style={{ width: "100%" }}>
      <Card style={{ width: "100%" }}>

        <Space direction="vertical" size={8} style={{ width: "100%" }} >

          <Flex justify='flex-end' style={{ width: "100%" }}>
            <Button type='primary' onClick={e => createTag()} >Tai site map</Button>
          </Flex>
        </Space>

      </Card>

    </Space>
  )
}
export default ProductTag;